module.exports = __webpack_public_path__ + "static/media/sbf-no-36-press.bc96fd80.png";